import { render, staticRenderFns } from "./DashBoardControlInterno.vue?vue&type=template&id=64821c69"
import script from "./DashBoardControlInterno.vue?vue&type=script&lang=js"
export * from "./DashBoardControlInterno.vue?vue&type=script&lang=js"
import style0 from "./DashBoardControlInterno.vue?vue&type=style&index=0&id=64821c69&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports